import { useState, useRef, useEffect } from "react";

export default function CustomDropdown({
  value,
  onChange,
  options = [],
  placeholder = "Select or type...",
  label,
  required = false,
}) {
  const [search, setSearch] = useState(value || "");
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const filtered = options.filter((item) =>
    item.toLowerCase().includes(search.toLowerCase()),
  );

  useEffect(() => {
    setSearch(value || "");
  }, [value]);

  // close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!ref.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (val) => {
    onChange(val);
    setSearch(val);
    setOpen(false);
  };

  const handleCreate = () => {
    if (!search.trim()) return;
    handleSelect(search);
  };

  return (
    <div ref={ref} className="relative">
      {label && (
        <div className="font-semibold mb-1">
          {label} {required && <span className="text-red-500">*</span>}
        </div>
      )}

      <input
        type="text"
        value={search}
        placeholder={placeholder}
        className="w-full text-sm border border-gray-300 px-2 py-2 rounded focus:outline-none focus:ring-1 focus:ring-sky-500"
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          setSearch(e.target.value);
          setOpen(true);
        }}
      />

      {open && (
        <div className="absolute z-50 bg-white border border-gray-300 w-full mt-1 rounded shadow max-h-72 overflow-y-auto">
          {filtered.map((item, i) => (
            <div
              key={i}
              className="px-3 py-2 text-sm hover:bg-sky-100 cursor-pointer"
              onClick={() => handleSelect(item)}
            >
              {item}
            </div>
          ))}

          {/* create option */}
          {search &&
            !options.some(
              (opt) => opt.toLowerCase() === search.toLowerCase(),
            ) && (
              <div
                className="px-3 py-2 text-sm bg-green-50 hover:bg-green-100 cursor-pointer font-medium"
                onClick={handleCreate}
              >
                ➕ Create "{search}"
              </div>
            )}

          {filtered.length === 0 && !search && (
            <div className="px-3 py-2 text-sm text-gray-500">No options</div>
          )}
        </div>
      )}
    </div>
  );
}
